import styled from "styled-components";
import {
  SPIN_BONUS_IMG,
  BONUS_IMG,
  RefreshOutlined,
  IMG_WALLET_BG,
} from "@assets";
import {
  REJECTED_SK,
  REQUESTED_SK,
} from '@constants';

export const RootContainer = styled.div`
position: relative;
height: 100vh;
overflow: hidden;
`;

export const RefreshIcon = styled(RefreshOutlined)`
  font-size: 24px;
  color: #fff;
`;

export const TopContainer = styled.div`
position: relative;
padding: 14px 16px;
`;

export const TopBg = styled.div`
width: 100%;
padding: 16px 0;
border-radius: 15px 70px 15px 15px;
background-image: url(${IMG_WALLET_BG});
background-size: cover;
background-repeat: no-repeat;
background-position: center;
`;

export const Layer = styled.div`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: linear-gradient(0deg, rgba(105, 12, 12, 0.50) 0%, rgba(105, 12, 12, 0.50) 100%);
border-radius: 15px 70px 15px 15px;
`;

export const TopBox = styled.div`
padding: 0;
border-radius: 15px;
background: linear-gradient(180deg, #FFF970 0%, #E68A00 35%);
box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
position: relative;
`;

export const TopWrapper = styled.div`
width: 100%;
padding: 0;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 6px;
position: relative;
background-color: transparent;
z-index: 1000;

svg {
  width: 50px !important;
  height: auto !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  margin-top: 14px !important;
}
`;

export const TopTitle = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #fff;
`;

export const BalanceText = styled.div`
font-size: 22px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #FECB01;
`;

export const LabelsContainer = styled.div`
padding: 16px 16px 0 16px;
display: flex;
align-items: center;
justify-content: center;
z-index: 100;
gap: 2px;

@media screen and (max-width: 375px) {
  padding: 16px 8px 0 8px;
}
`;

export const LightText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
color: #FECB01;
`;

export const LightTextLabel = styled.div`
color: #fff;
font-size: 14px;
font-style: normal;
line-height: 1.5;
font-weight: 400;
padding-bottom: 4px;

@media screen and (max-width: 375px) {
font-size: 12px;
}
`;

export const LabelWrapper = styled.div`
flex: 1;
text-align: center;
background: rgba(0, 0, 0, 0.50);
backdrop-filter: blur(25px);
z-index: 100;
padding: 10px;

:first-child {
  border-radius: 15px 0px 0px 15px;
}

:last-child {
  border-radius: 0px 15px 15px 0px;
}

@media screen and (max-width: 375px) {
padding: 8px 4px;
}

@media screen and (max-width: 295px) {
padding: 8px 0px;
}
`;

export const ActionLabel = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 1.5;

@media screen and (max-width: 326px) {
  font-size: 14px;
}
`;

export const ActionButton = styled.div`
flex: 1;
height: 56px;
display: flex;
justify-content: center;
align-items: center;
gap: 10px;

border-radius: 16px;
border: 2px solid ${props => props.transparent === 1 ? '#FFCB2F' : '#CC0D0E'};
background: ${props => props.transparent === 1 ? 'linear-gradient(180deg, #F9B200 0%, #EC7601 100%)' : 'linear-gradient(180deg, #F00F11 0%, #CC0D0E 36%)'};
box-shadow: 0px 7px 10px 0px rgba(255, 255, 255, 0.25) inset;
cursor: pointer;

${ActionLabel} {
  color: ${props => props.transparent === 1 ? '#fff': '#fff'};
}
`;

export const ActionsWrapper = styled.div`
width: 100%;
margin-top: 16px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
`;

export const SeeAllText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #FEBF15;
cursor: pointer;
`;

export const ListTitle = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #4F4F4F;
`;

export const ListContainer = styled.div`
height: calc(100vh - 450px);
overflow-y: auto;
padding: 0 16px;

.loader {
    height: calc(100vh - 450px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-box {
    height: calc(100vh - 450px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const ListItem = styled.div`
  padding: 12px;
  margin-bottom: 4px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background-color: #F7F7F7;
  border-radius: 16px;

  @media screen and (max-width: 375px) {
      padding: 16px 8px;
      gap: 6px;
    }

  @media screen and (max-width: 305px) {
    padding: 12px 6px;
    }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 4px;
`

export const ItemImage = styled.img.attrs({
  alt: 'img'
})`
width: 35px;
height: 35px;
border-radius: 4px;
object-fit: cover;
`;

export const InfoWrapper = styled.div`
flex: 1;
display: flex;
width: 100%;

> :nth-child(1) {
  flex: 1;
}
`;

export const Wrapper = styled.div`
gap: 4px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: flex-start;
`;

export const ItemText = styled.div`
flex: 1;
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
text-transform: capitalize;
color: #1E1E1E;

  @media screen and (max-width: 400px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const DateText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #616161;

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const AmountText = styled.div`
white-space: nowrap;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: normal;
color: #FEBF15;

  @media screen and (max-width: 400px) {
    font-size: 16px;
  }

  @media screen and (max-width: 300px) {
    font-size: 12px;
  }
`;

export const StatusText = styled.div`
display: flex;
padding: 2px 12px;
flex-direction: column;
justify-content: center;
align-items: center;

white-space: nowrap;
font-size: 11px;
font-style: normal;
font-weight: 700;
line-height: 1.5;
text-transform: capitalize;
color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#fff"
      : props.status === REJECTED_SK
        ? "#ffffff"
        : "#fff"};
background-color: ${(props) =>
    props.status === REQUESTED_SK
      ? "#CC0D0E"
      : props.status === REJECTED_SK
        ? "#FF6262"
        : "#FEBF15"};
border-radius: 10px;
display: flex;
align-items: center;
justify-content: center;

  @media screen and (max-width: 300px) {
    font-size: 11px;
  }
`;

export const BonusStatusText = styled(StatusText)`
text-transform: none;
width: auto;
color: ${(props) => props.status === 'Used' ? "#fff" : "#fff"};
background-color: ${(props) => props.status === 'Used' ? "#999" : "#FEBF15"};
`;

export const ImageWrapper = styled.div`
object-fit: cover;
display: flex;
align-items: center;
justify-content: center;

svg {
  width: 35px;
  height: 35px;
  margin-left: -3px;
}
`;

const Image = styled.img.attrs({
  alt: "img",
})`
width: 100%;
object-fit: contain;
align-self: center;
`;

export const SpinImage = styled(Image).attrs({
  src: SPIN_BONUS_IMG,
})``;

export const BonusImage = styled(Image).attrs({
  src: BONUS_IMG,
})``;

export const ExpiredLabel = styled.span`
white-space: nowrap;
color: #EE3530;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 1.5;

  @media screen and (max-width: 390px) {
    font-size: 13px;
  }

@media screen and (max-width: 425px) {
    font-size: 12px;
  }

@media screen and (max-width: 375px) {
    font-size: 11px;
  }

@media screen and (max-width: 305px) {
    font-size: 10px;
  }
`;

export const CommentText = styled(ExpiredLabel)`
white-space: normal;
word-break: break-all;
`;

export const ExpiredText = styled(ExpiredLabel)`
color: #5C5C5C;
`;

export const ListRootContainer = styled.div`
height: calc(100vh - 340px);
position: relative;
`;

export const ListTitleWrapper = styled.div`
display: flex;
justify-content: space-between;
padding: 0 16px 6px 16px;

@media screen and (max-width: 375px) {
  padding: 0 12px 6px 12px;
}

  @media screen and (max-width: 305px) {
    padding: 0 8px 6px 8px;
    }
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 450px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const BoldText = styled.div`
padding-top: 16px;
font-size: 16px;
font-weight: 700;
color: #2A2A2A;
line-height: 1.5;
`;

export const NoResultText = styled.div`
	padding-top: 8px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #5D5189;
`;